export function isDocumentAction(action) {
    return "payload" in action && action.payload != null;
}
/** @deprecated Use isDocumentAction instead */
export const isDocumentReduxAction = isDocumentAction;
//# sourceMappingURL=types.js.map